<div class="step-container">
  <div>
    <div class="side-header">
      <p class="side-header-text">{{ "NO_PROVIDER_SERVICE.SIDE_BAR.7" | translate }}</p>
      <tui-icon
        icon="tuiIconCloseLarge"
        style="cursor: pointer"
        (click)="closeCanvas()"
      ></tui-icon>
    </div>
    <div class="split"></div>
    <app-select-provider-list
      [MaxHeight]="'calc(100vh - 252px)'"
      [MinHeight]="'100%'"
      [ProductId]="product.productId"
      [Product]="product"
      [ZoneId]="ZoneId"
      [ProviderSelected]="ProviderSelected"
      (providerSelectEmitter)="ProviderSelected = $event"
    ></app-select-provider-list>
  </div>

  <div class="footer-container">
    <div class="buttons-container">
      <!-- <div
        class="button-grey button-padding-10 button-text"
        (click)="closeCanvas()"
      >{{ "USER_NAVBAR.6" | translate }}</div> -->
      <div
        (click)="assignProvider()"
        class="button-green button-padding-10 button-text"
        [ngClass]="{ 'button-disable': !ProviderSelected || SaveLoading }"
      >{{ "NO_PROVIDER_SERVICE.SIDE_BAR.10" | translate }}</div>

      <img
        class="loading-spinner"
        *ngIf="SaveLoading"
        src="../../../../../assets/loading-spinner.gif"
        alt=""
      />
    </div>
  </div>
</div>

<!-- <div class="modal-all">
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ "modals.assign_provider.title" | translate }}
    </h4>
    <button
      appearance="icon"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="closeCanvas()"
    ></button>
  </div>

  <div class="modal-body">
    <div id="modal_assign_provider_service"></div>
    <div id="modal_assign_provider_service_alert"></div>

    <form
      [formGroup]="assignForm"
      (ngSubmit)="assignProvider()"
      class="d-flex flex-column gap-4"
    >
      <div class="row">
        <div class="col" [formGroup]="filterForm">
          <tui-input
            formControlName="nameFilter"
            class="input_form"
            tuiTextfieldIconLeft="tuiIconSearch"
            [tuiTextfieldLabelOutside]="true"
          >
            {{ "modals.assign_provider.search_placeholder" | translate }}
          </tui-input>
        </div>
      </div>

      <div class="form-group">
        <div class="div_drivers_scroll">
          <ng-container *ngIf="!(listLoading$ | async); else listLoadingTpl">
            <ng-container
              *ngIf="(filteredProviders$ | async)?.length; else noProvidersTpl"
            >
              <div
                *ngFor="
                  let provider of filteredProviders$ | async;
                  trackBy: trackById
                "
                (click)="selectProvider(provider)"
                class="item_pointer"
                [class.active_option_provider]="
                  assignForm.value.providerId === provider.id
                "
              >
                <p class="p_fs_15">
                  <b>{{ provider.name }}</b>
                </p>
                <small> ({{ provider.address }}) </small>
              </div>
            </ng-container>

            <ng-template #noProvidersTpl>
              <p class="text-center fst-italic">
                {{ "modals.assign_provider.no_providers" | translate }}
              </p>
            </ng-template>
          </ng-container>

          <ng-template #listLoadingTpl>
            <tui-loader size="l"></tui-loader>
          </ng-template>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      tuiButton
      type="button"
      class="tui-space_right-3 tui-space_bottom-3 btn_desc but_footer"
      appearance="secondary"
      (click)="closeCanvas()"
    >
      {{ "modals.assign_provider.discard" | translate }}
    </button>
    <button
      tuiButton
      type="button"
      class="tui-space_right-3 tui-space_bottom-3 but_footer"
      appearance="primary-button"
      icon="tuiIconPlusCircleLarge"
      (click)="assignProvider()"
      [disabled]="assignForm.invalid || ((buttonLoading$ | async) ?? false)"
    >
      <ng-container *ngIf="!(buttonLoading$ | async)">
        {{ "modals.assign_provider.assign" | translate }}
      </ng-container>
      <tui-loader *ngIf="buttonLoading$ | async" size="s"></tui-loader>
    </button>
  </div>

  <br />
</div> -->
